import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { fetchProjectStats } from "../../../REDUX/actions/appProjects";
import ProjectsTable from "./ProjectsTable";

const formatEuro = (value) =>
  `${(Number(value) || 0).toLocaleString("fr-FR", {
    maximumFractionDigits: 0,
  })} €`;

/**
 * Projects tab (deck "Onglet Prospect - Projet"): slide-2 stat cards over the
 * project list.
 */
const ProjectsTab = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation("common");
  const { stats, version } = useSelector((state) => state.appProjectsReducer);
  // "Devis acceptés à confirmer" tile = a filter on the list below (N1).
  const [toConfirm, setToConfirm] = useState(false);

  const abortRef = useRef(null);
  useEffect(() => {
    abortRef.current?.abort();
    abortRef.current = new AbortController();
    dispatch(fetchProjectStats(abortRef.current.signal));
    return () => abortRef.current?.abort();
  }, [dispatch, version]);

  const cards = [
    {
      label: "Interested projects in progress",
      value: stats?.interested ?? 0,
      bgColor: "#577b87",
    },
    {
      label: "Total projects in progress",
      value: stats?.total ?? 0,
      bgColor: "#8fa9b8",
    },
    {
      label: "Potential revenue of interested projects in progress",
      value: formatEuro(stats?.potentialRevenue),
      bgColor: "#345d68",
    },
    {
      label: "Accepted quotes to confirm",
      value: stats?.toConfirm ?? 0,
      // Logistique "Prêt à récupérer" copper.
      bgColor: "#c9762e",
      onClick: () => setToConfirm((value) => !value),
      active: toConfirm,
    },
  ];

  return (
    <div>
      <div className="row flex-nowrap g-3 pt-2 pb-2 overflow-auto">
        {cards.map(({ label, value, bgColor, onClick, active }) => (
          <div className="col-3" key={label}>
            <div
              className={`p-3 px-4 br20 flex-1 flex-column h-100 ${onClick ? "pointer" : ""}`}
              style={{
                backgroundColor: bgColor,
                outline: active ? "3px solid #14748e" : undefined,
              }}
              onClick={onClick}
            >
              <span className="d-block text-white sBold f20 mb-1">
                {t(`${label}`)}
              </span>
              <span className="d-block text-white text-nowrap bold f33">
                {value}
              </span>
            </div>
          </div>
        ))}
      </div>
      <ProjectsTable toConfirm={toConfirm} />
    </div>
  );
};

export default ProjectsTab;
